import { useQuery } from "@tanstack/react-query";

import { appsApi } from "@/api/admin";

export function AppsPage() {
  const { data: apps, isLoading } = useQuery({
    queryKey: ["admin", "apps"],
    queryFn: () => appsApi.list(),
  });

  const { data: grants } = useQuery({
    queryKey: ["admin", "grants"],
    queryFn: () => appsApi.grants(),
  });

  return (
    <div>
      <header className="mb-6">
        <h1 className="font-display text-2xl text-wm-white">Apps</h1>
        <p className="mt-1 text-sm text-wm-gray-100/60">
          Every app in the Windmill catalog. Edit roles and grants here.
        </p>
      </header>

      {isLoading ? (
        <p className="text-sm text-wm-gray-100/60">Loading…</p>
      ) : (
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-3">
          {apps?.apps.map((app) => (
            <article
              key={app.id}
              className="rounded-lg border border-white/5 bg-wm-black/30 p-4"
            >
              <div className="mb-2 flex items-baseline justify-between">
                <h3 className="font-display text-lg text-wm-white">{app.name}</h3>
                <a
                  href={app.url}
                  target="_blank"
                  rel="noreferrer"
                  className="text-xs text-wm-purple-bright hover:underline"
                >
                  open ↗
                </a>
              </div>
              <p className="mb-3 text-xs text-wm-gray-100/60">
                {app.description ?? "—"}
              </p>
              <div className="flex flex-wrap gap-1">
                {(app.roles ?? []).map((role) => (
                  <span
                    key={role}
                    className="rounded-full bg-wm-purple-bright/10 px-2 py-0.5 text-[11px] text-wm-purple-bright"
                  >
                    {role}
                  </span>
                ))}
              </div>
              {grants && (
                <div className="mt-3 text-[11px] text-wm-gray-100/40">
                  {grants.filter((g) => g.app_slug === app.slug).length} grants
                </div>
              )}
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
